module.exports = new __parcel__URL__("restricted.65d4317c.svg").toString();